// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"1aa9bde7","229":"564dba34","244":"601d2c3f","354":"eec85136","863":"f2977489"}[chunkId] + ".chunk.css";
};